import { useContext } from 'react';

import { ActiveMenuContext } from 'contexts/ActiveMenuContext';

export const useActiveMenu = () => {
  const context = useContext(ActiveMenuContext);

  if (context === undefined) {
    throw new Error('useActiveMenu must be used within the ActiveMenuProvider');
  }

  return context;
};
